import { AuthService } from '../auth/auth.service';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {
  isLoading = false;
  password: string;
  newPassword: string;
  newPasswordConfirm: string;
  passwordsDoesntMatch = false;

  constructor(
    private _authService: AuthService,
    private _translate: TranslateService,
    private _toastrService: ToastrService,
    private _router: Router,
    private _route: ActivatedRoute
  ) { }

  ngOnInit() {
  }

  changePassword() {
    if (this.newPassword !== this.newPasswordConfirm)
      this.passwordsDoesntMatch = true;
    else
      this.verifyUser();
  }

  doChangePassword() {
    this._authService.httpChangePassword(this.password, this.newPassword, this.newPasswordConfirm)
      .subscribe(
        data => {
          this._translate.get('Messages.ChangePasswordSuccess').subscribe(translated => {
            this._toastrService.success(translated);
            this._authService.logout();
            this._router.navigate(['/signin'], { relativeTo: this._route });
          });
        },
        err => {
          this._translate.get('Messages.ChangePasswordError').subscribe(translated => {
            this._toastrService.error(translated);
          });
        });
  }

  verifyUser() {
    this.isLoading = true;

    this._authService.verifyUser(this.password).subscribe(
      data => {
        if (data.verified === true) {
          this.doChangePassword();
        }
      },
      err => {
        if (err.error['errorCode'] === 'Err_InvalidPassword') {
          this._translate.get('Messages.WrongPasswordTryAgain').subscribe(translated  => {
            this._toastrService.error(translated);
            this.isLoading = false;
          });
        } else {
          this._toastrService.error('Something went wrong');
        }
      }, () => this.isLoading = false
    );
  }

}



// WEBPACK FOOTER //
// C:/TeamCity/BuildAgent3/work/c38c6eefb6a115e8/HSG.Accounting/HSG.Accounting.MonitoringMobileApp/src/app/change-password/change-password.component.ts